import firebase from './firebaseBundle'

const emailExistsInFirebase = async (email) => {
  const signInMethods = await firebase.auth().fetchSignInMethodsForEmail(email)

  return signInMethods.length > 0
}

export default emailExistsInFirebase
